<div class="container">
  <div class="pt-3 d-none d-lg-block">
    <div class="rewards-detail-back-btn text-white cursor-pointer gloss-black" (click)="goBack()" >
      <span class="material-icons"> arrow_back_ios </span>
    </div>
  </div>
  <fgb-points-summary-bar
    [marketplaceItemGroup]="marketplaceItemType.group"
  ></fgb-points-summary-bar>
</div>

<!-- Points Summary -->
<div class="container ps-0">
  <fgb-points-summary-bar></fgb-points-summary-bar>
</div>

<fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
